import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import Loading from "../../../components/loading";
import associateServices from "../../../services";
import moment from "moment";
import InstrumentIcon from "../../../components/instrument-icon";
import Big from "big.js";
import NoData from "../../../components/no-data";
import {Tooltip} from "react-tooltip";
import SvgIcon from "../../../components/svg-icon";

const TipDetailModal = props => {
    const {t} = useTranslation()
    const {handleClose} = props

    const [reference, setReference] = useState(false)
    const [loading, setLoading] = useState(true)
    const [bet, setTip] = useState({})
    const location = useLocation()


    useEffect(() => {
        if (reference)
            associateServices.getTipDetail({
                id: reference
            }).then(res => {
                setTip(res?.data || {})
                setTimeout(() => setLoading(false), 260)
            })
    }, [reference])

    const getParams = (key) => {
        const searchParams = new URLSearchParams(location?.search);
        return searchParams.get(key);
    }


    useEffect(() => {
        const bdy = document.body
        bdy.classList?.add('modal-open')

        const mdl = document.getElementById('tip-detail-modal')
        mdl.classList?.add('show')

        mdl.style.display = 'block'
        mdl.style.backgroundColor = 'rgba(0,0,0,.7)'

        setReference(getParams('reference'))

        return () => {
            bdy.classList?.remove('modal-open')
            mdl.classList?.remove('show')

        }
    }, [getParams])

    return (
        <div
            className="modal fade"
            id="tip-detail-modal"
            onClick={handleClose}
        >

            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal__content" onClick={e => e.stopPropagation()}>
                        {
                            loading ? <Loading/> :
                                bet?.amount ?
                                    <>
                                        <div className="modal__head">
                                            <h6 className="modal__title">
                                                {t('tip-detail.title')}
                                            </h6>
                                            <button
                                                className="modal__close"
                                                type="button"
                                                onClick={handleClose}
                                            >
                                                <SvgIcon id={'x'}/>
                                            </button>
                                        </div>
                                        <div className="bet">
                                            <div className="bet__head">
                                                <h6 className="bet__game">{bet?.game?.name || ''}</h6>


                                                <div className="bet__placed">
                                                    <span className="bet__by">{t('tip-detail.tipped-by')}</span>
                                                    <span
                                                        className="chat__user d-flex align-items-center justify-content-center">
                                                         <Tooltip className="tooltip-me" anchorSelect={`#next-rank`}>
                                                            <span className="xtable__coin gap-2">
                                                                <SvgIcon id={bet?.from_rank}/>
                                                                {bet?.from_rank}
                                                                {/*{t(`modals.vip.progress.${bet?.from_rank}`)}*/}
                                                            </span>
                                                         </Tooltip>

                                                        <span id="next-rank" className="d-flex gap-2">
                                                            <SvgIcon id={bet?.from_rank}/>
                                                        </span>
                                                        <button className="chat__name" type="button">
                                                          {bet?.from}
                                                        </button>
                                                      </span>
                                                    <p>{moment.unix(bet?.timestamp).format('MMMM Do YYYY, H:mm:ss a')}</p>
                                                </div>


                                                <ul className="bet__info">
                                                    <li>
                                                        <span>{t('tip-detail.currency')}</span>
                                                        <div className="xtable__coin xtable__coin--green">
                                                            <InstrumentIcon code={bet?.code}/>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <span>{t('tip-detail.amount')}</span>
                                                        <div className="xtable__coin">
                                                            {Big(bet?.amount || 0).toFixed(8)}
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <span>{t('tip-detail.to')}</span>
                                                        <div
                                                            className="xtable__text">{bet.to}</div>
                                                    </li>

                                                </ul>

                                            </div>

                                        </div>
                                    </>
                                    :
                                    <NoData/>
                        }
                    </div>
                </div>
            </div>
        </div>

    )

}

export default TipDetailModal
